import * as moment from 'moment';
import { IFilters, IAllFilters } from '../types';

const today = moment().endOf('day');
const yearAgo = moment().startOf('day').subtract(1, 'years');

export const defaultFilters: IFilters = {
  dateFrom: yearAgo.toDate(),
  dateTo: today.toDate(),
  showArchive: false,
  myLinks: false,
  parameters: [],
  linksPerPage: 10,
};

export const allDefaultFilters: IAllFilters = {
  ...defaultFilters,
  page: 1,
  searchTerm: '',
};



// WEBPACK FOOTER //
// ./src/views/Links/services/filters.ts